import React from "react";
import { useLocation, Link } from "react-router-dom";
import Logo from "../../assets/rxultimate.png";
import LoginImage from "../../assets/3836182.jpg";
import { HiOutlineMail } from "react-icons/hi";
import { BsTelephone } from "react-icons/bs";
import { IoArrowBackOutline } from "react-icons/io5";

const ResetPasswordSent = () => {
  const location = useLocation();
  const { method = "email", contact = "" } = location.state || {};

  const renderInstructions = () => {
    if (method === "email") {
      return (
        <>
          <div className="flex justify-center items-center w-16 h-16 bg-blue-100 rounded-full mx-auto mb-6">
            <HiOutlineMail className="text-blue-600 text-3xl" />
          </div>
          <h3 className="text-xl md:text-2xl font-semibold text-[#526484] mb-4 text-center">
            Check Your Email
          </h3>
          <p className="text-[#526484] text-center mb-2">
            We've sent password reset instructions to:
          </p>
          <p className="text-blue-600 font-medium text-center mb-6">
            {contact || "your email address"}
          </p>
          <div className="space-y-4 text-center">
            <p className="text-[#526484] text-sm">
              Please check your email and follow the link to reset your password.
              The link will expire in 24 hours.
            </p>
            <p className="text-[#526484] text-sm">
              If you don't see the email, check your spam folder or click below
              to try again.
            </p>
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className="flex justify-center items-center w-16 h-16 bg-blue-100 rounded-full mx-auto mb-6">
            <BsTelephone className="text-blue-600 text-3xl" />
          </div>
          <h3 className="text-xl md:text-2xl font-semibold text-[#526484] mb-4 text-center">
            Check Your Phone
          </h3>
          <p className="text-[#526484] text-center mb-2">
            We've sent a verification code to:
          </p>
          <p className="text-blue-600 font-medium text-center mb-6">
            {contact || "your phone number"}
          </p>
          <div className="space-y-4 text-center">
            <p className="text-[#526484] text-sm">
              Please enter the 6-digit code to reset your password.
              The code will expire in 24 hours.
            </p>
            <p className="text-[#526484] text-sm">
              If you don't receive the code within a few minutes, click below
              to try again.
            </p>
          </div>
        </>
      );
    }
  };

  return (
    <div className="min-h-screen w-full bg-white">
      <div className="flex flex-col md:flex-row h-full min-h-screen">
        {/* Content Section */}
        <div className="w-full md:w-1/2 flex items-center justify-center p-4 md:p-8 lg:p-12">
          <div className="w-full max-w-md">
            <div className="mb-8">
              <div className="flex justify-center md:justify-start mb-8">
                <img
                  src={Logo}
                  alt="rxultimate"
                  className="h-16 md:h-20 w-auto"
                />
              </div>
            </div>

            <div className="bg-white p-6 rounded-lg">
              {renderInstructions()}

              <div className="flex flex-col space-y-3 mt-8">
                <Link
                  to="/login/forgot-password"
                  className="text-center w-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium py-3 px-4 rounded-lg transition-colors"
                >
                  Try Again
                </Link>
                <Link
                  to="/login"
                  className="inline-flex items-center justify-center text-blue-600 hover:text-blue-800 font-medium text-sm"
                >
                  <IoArrowBackOutline className="mr-1" /> Back to Login
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Image Section - Hidden on small screens */}
        <div className="hidden md:flex md:w-1/2 bg-[#f5f6fa] items-center justify-center">
          <img
            src={LoginImage}
            alt="Reset password illustration"
            className="w-4/5 max-w-lg object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordSent;